<div>

  <!-- Navigation Bar -->
  <app-nav-bar></app-nav-bar>


  <!-- Hero Start -->
  <section class="position-relative"
    style="background-image: url('../../../assets/images/tech-mesh.svg');background-size: cover;background-repeat: no-repeat;background-position: center;background-color:#000f66; padding: 225px 0 0">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-sm-6">
          <div class="hero-title pr-lg-5">
            <h1 class="text-white">
              <span class="italic mr-3">We Are</span>
            </h1>
            <h1 class="text-white"><span class="italic mr-3">Your</span> <span
                class="slogan-text not-italic">Team</span>
            </h1>
            <h1 class="text-white"><span class="italic mr-3">On Your</span> <span
                class="slogan-text not-italic">Time</span>
            </h1>
            <h1 class="text-white"><span class="italic mr-3">For Your</span> <span
                class="slogan-text not-italic">Goals.</span></h1>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="mt-5 mt-lg-0 laptop-holder">
            <img src="/assets/images/macbook-with-image.svg" alt="" class="img-fluid mx-auto d-block laptop-image">
          </div>
        </div>
      </div>
    </div>
    <div class="image-container">
      <div class="image-holder">
        <img src="../../../assets/images/PATTERN 2 (1).svg" class="top-right-pattern-image">
      </div>
    </div>

    <div style="width: 100%;margin-top: 6rem;">
      <svg viewBox="0 0 1440 70" fill="none" xmlns="http://www.w3.org/2000/svg">
        <ellipse cx="718" cy="191" rx="959" ry="191" fill="white" />
      </svg>
    </div>
  </section>

  <div class="text-center arrow">
    <a class="link" href="javascript:void(0);" [ngxScrollTo]="'#who-we-are'" [ngxScrollToOffset]="1">
      <span class="link__arrow">
        <span></span>
        <span></span>
      </span>
      <span class="link__line"></span>
    </a>
  </div>
  <!-- Hero End -->

  <!-- Various Page Sections -->
  <app-who-we-are></app-who-we-are>
  <app-why-choose-us></app-why-choose-us>
  <!-- <app-our-clients></app-our-clients> -->
  <app-awards-and-recognition></app-awards-and-recognition>
  <!-- <app-our-team></app-our-team> -->
  <app-footer></app-footer>
</div>
